import { createAction, createReducer } from '@reduxjs/toolkit';
import { IAction, IDebito } from './interface/apiInterfaces';
import { IDebits, IInitialState } from './interface/reduxInterfaces';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  dateSearch: {
    start: '',
    end: '',
  },
  debits: [],
};

export const getOutstandingDebitsListFromApi = createAction(
  '@outstandingDebitsApp/GET_OUTSTANDING_DEBITS_LIST_FROM_API'
);
export const gotOutstandingDebitsListFromApi = createAction<any>(
  '@outstandingDebitsApp/GOT_OUTSTANDING_DEBITS_LIST_FROM_API'
);
export const gotErrorFromOutstandingDebitsListFromApi = createAction(
  '@outstandingDebitsApp/GOT_ERROR_OUTSTANDING_DEBITS_LIST_FROM_API'
);
export const eraserOutstandingDebitsList = createAction(
  '@outstandingDebitsApp/ERASER_OUTSTANDING_DEBITS_LIST'
);
export const logoutOutstandingDebitsApp = createAction(
  '@outstandingDebitsApp/LOGOUT_OUTSTANDING_DEBITS_APP'
);

const outstandingDebitsAppReducer = createReducer(INITIAL_STATE, {
  [getOutstandingDebitsListFromApi.type]: (state) => ({
    ...state,
    isActive: false,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
  }),
  [gotOutstandingDebitsListFromApi.type]: (state, action: IAction) => ({
    ...state,
    isActive: true,
    gotError: false,
    gotSuccess: true,
    isLoading: false,
    dateSearch: {
      start: action.payload.data_de_pesquisa.de,
      end: action.payload.data_de_pesquisa.ate,
    },
    debits: action.payload.debitos.map((cliente: IDebito) => {
      const data: IDebits = {
        account: cliente.conta,
        accountFormat: cliente.formato_conta,
        agency: cliente.agencia,
        cel: cliente.celular,
        cnpjCpf: cliente.cpf_cnpj,
        companyName: cliente.nome_razaoSocial,
        digit: cliente.digito,
        email: cliente.email,
        fare: cliente.tarifa,
        id: cliente.id,
        partner: cliente.razao_social,
        referenceDate: cliente.data_referencia,
        value: cliente.valor,
      };
      return data;
    }),
  }),
  [gotErrorFromOutstandingDebitsListFromApi.type]: (state) => ({
    ...state,
    gotError: true,
    gotSuccess: false,
    isLoading: false,
  }),
  [eraserOutstandingDebitsList.type]: (state) => ({
    ...state,
    gotError: false,
    gotSuccess: false,
    isLoading: false,
    debits: [],
  }),
  [logoutOutstandingDebitsApp.type]: (state) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: false,
    dateSearch: {
      start: '',
      end: '',
    },
    debits: [],
  }),
});

export default outstandingDebitsAppReducer;
